// Spoiler
window.spoiler = {
  /* Флаг индикатор открытого спойлера
        1 - спойлер открыт, 0 - спойлер закрыт */
  // spoilerFlag: 1,

  // Константа префикса для id основной кнопки переключателя
  SPOILER_TOGGLE_BTN_PREFIX: "spoiler-toggle-",
  // Константа префикса для id карточки
  CARD_PREFIX: "product-card-modif-",
  // Константа имени класса для дополнительной кнопки переключателя
  SPOILER_TOGGLE_BTN_IS_EXTRA_CLS: "is--extra-btn",

  init: function () {
    const self = this;
    const elements = document.querySelectorAll('a[data-action="spoiler"]');

    for (const el of elements) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        self.toggle($(this));
      });
    }
  },

  /**
   *
   * @param {jQuery} $btn
   * @param {bool} isOpen
   */
  switchSpoilerBtn: function ($btn, isOpen) {
    const OPEN_CLASS = "open";
    const textElemClassName = $btn.data("textElCls") ?? "";

    let textToggle = $btn.data("textToggle");
    let text = $btn.text();
    let $textElements = null;

    if (textElemClassName) {
      $textElements = $(`.${textElemClassName}`);
    }

    if ($textElements.length) {
      $textElements.each(function (_, el) {
        const $textEl = $(el);

        textToggle = $textEl.data("textToggle");
        text = $textEl.text();

        $textEl.toggleClass(OPEN_CLASS, isOpen);
        $textEl.data("textToggle", text);
        $textEl.text(textToggle);
      });
    } else {
      $btn.toggleClass(OPEN_CLASS, isOpen);
      $btn.data("textToggle", text);
      $btn.text(textToggle);
    }
  },

  toggle: function ($this) {
    const self = this;
    const isExtraBtn =
      $this.hasClass(self.SPOILER_TOGGLE_BTN_IS_EXTRA_CLS) || !$this.attr("id");
    const spoilerSelector = $this.attr("href");
    const $spoiler = $(spoilerSelector);
    const spoilerIsVisible = $spoiler.is(":visible");
    const spoilerId = spoilerSelector.replace("#", "");
    const cardSelector = `#${self.CARD_PREFIX}${spoilerId}`;
    const $card = $(cardSelector);

    if ($card.length) {
      $card.toggleClass("is--open", !spoilerIsVisible);
    }

    if (isExtraBtn) {
      const btnSelector = "#" + self.SPOILER_TOGGLE_BTN_PREFIX + spoilerId;
      const $btn = $(btnSelector);

      if ($btn.length) {
        self.switchSpoilerBtn($btn, !spoilerIsVisible);

        if (spoilerIsVisible && window.scroll) {
          window.scroll.scrollToObject(
            $card.length ? cardSelector : btnSelector,
            -160
          );
        }
      }
    } else {
      self.switchSpoilerBtn($this, !spoilerIsVisible);
    }

    if (spoilerIsVisible) {
      $spoiler.fadeOut();
    } else {
      $spoiler.fadeIn();
    }
  },
};

window.spoiler.init();
